module.exports = __webpack_public_path__ + "static/media/shape.f1205bde.png";